import { Navigate, useSearchParams } from 'react-router';
import { SentinelWorkspace } from '@/modules/sentinel-workspace/sentinel-workspace';
import { CASE_PARAM, VIEW_PARAM } from '@/modules/sentinel-workspace/benchmark/benchmark-panel';

/** Benchmark used to be a section of the workspace: its old links open its own page, with the case and view kept. */
function oldBenchmarkLink(params: URLSearchParams): string | null {
  const section = params.get('section');
  if (section !== 'benchmark' && section !== 'monitoring') return null;
  const kept = new URLSearchParams();
  if (section === 'monitoring') kept.set(VIEW_PARAM, 'monitoring');
  else {
    for (const key of [CASE_PARAM, VIEW_PARAM]) {
      const value = params.get(key);
      if (value) kept.set(key, value);
    }
  }
  const query = kept.toString();
  return `/sentinel-workspace/benchmark${query ? `?${query}` : ''}`;
}

export default function SentinelWorkspaceRoute() {
  const [searchParams] = useSearchParams();
  const redirect = oldBenchmarkLink(searchParams);
  if (redirect) return <Navigate replace to={redirect} />;
  return (
    <div data-sentinel-workspace-page className="flex h-[calc(100dvh-3rem)] md:h-screen w-full overflow-hidden">
      <SentinelWorkspace />
    </div>
  );
}
